import withLocator from './withLocator';

const generateLocatorsMap = (base: string, locatorsMap: object) => {
  const arrayMap = Object.fromEntries(
    Object.entries(locatorsMap).map(([blockName, elements]) => [
      blockName,
      typeof elements === 'string'
        ? withLocator(base, blockName)
        : Object.fromEntries(
            (elements as string[]).map((el: string) => [
              el,
              withLocator(base, blockName, el),
            ])
          ),
    ])
  ) as {[x: string]: any};

  return arrayMap;
};

export default generateLocatorsMap;
